import { useTranslation } from "react-i18next";

import LanguageSwitcher from "@/components/LanguageSwitcher";
import OnboardingWizard from "@/components/onboarding/OnboardingWizard";

/**
 * apps/web :: pages :: OnboardingPage
 *
 * Route-level wrapper around the onboarding wizard. Renders the page chrome
 * (eyebrow / title / subtitle) above `<OnboardingWizard />`. The wizard
 * owns all data-fetching, step state, and submit side-effects; this page
 * is deliberately thin.
 *
 * No TopNav or LearnerPortalShell here — the user hasn't finished onboarding
 * yet. A compact LanguageSwitcher sits in the top-right so users can pick
 * their language before the native_language wizard step.
 */
export default function OnboardingPage() {
  const { t, i18n } = useTranslation();

  return (
    <>
      <div className="flex justify-end px-md pt-sm">
        <LanguageSwitcher
          currentLang={i18n.language}
          onChange={(l) => void i18n.changeLanguage(l)}
          variant="compact"
        />
      </div>
      <section className="mx-auto w-full max-w-3xl px-md pb-lg sm:px-lg">
        <header className="mb-lg">
          <p className="text-xs font-semibold uppercase tracking-wide text-neutral-600">
            {t("onboarding.eyebrow")}
          </p>
          <h1
            data-testid="onboarding-heading"
            className="mt-xs font-display text-3xl font-bold text-brand-primary"
          >
            {t("onboarding.title")}
          </h1>
          <p className="mt-xs text-sm text-neutral-700">
            {t("onboarding.subtitle")}
          </p>
        </header>

        <OnboardingWizard />
      </section>
    </>
  );
}
